import { useEffect } from 'react';
import loadable from '@utils/loadable';

import withComponentName from '../../decorators/withComponentName';
import withMetatag from '../../decorators/metadataDecorators/metatagsTitleDecorator';

import topCollageImage from '../../assets/about/top-photo-collage-2023.png';
import bottomCollageImage from '../../assets/about/bottom-photo-collage-2023.png';
import topCollageImageMob from '../../assets/about/top-photo-collage-2023-mobile.png';
import bottomCollageImageMob from '../../assets/about/bottom-photo-collage-2023-mobile.png';

import Styles from './styles.module.scss';

const AboutUsTopSection = loadable(() => import('./AboutUsComponents/AboutUsTopSection'));
const AboutUsAdventureSection = loadable(() => import('./AboutUsComponents/AboutUsAdventureSection'));
const AboutUsCollageSection = loadable(() => import('./AboutUsComponents/AboutUsCollageSection'));
const AboutUsFalconsSection = loadable(() => import('./AboutUsComponents/AboutUsFalconsSection'));
const AboutUsChartsSection = loadable(() => import('./AboutUsComponents/AboutUsChartsSection'));
const AboutUsLocationSection = loadable(() => import('./AboutUsComponents/AboutUsLocationSection'));

const AboutUsComponent = () => {
  useEffect(() => {
    const preloader = document.querySelector('.cf-preloading-wrapper');
    if (preloader) {
      preloader.style.display = 'none';
    }
  }, []);

  return (
    <div className={Styles['about-wrapper']}>
      <AboutUsTopSection />
      <AboutUsAdventureSection />
      <AboutUsCollageSection
        collageClass="collage-top-background"
        image={topCollageImage}
        imagemob={topCollageImageMob}
      />
      <AboutUsFalconsSection />
      <AboutUsChartsSection />
      <AboutUsCollageSection
        collageClass="collage-bottom-background"
        image={bottomCollageImage}
        imagemob={bottomCollageImageMob}
      />
      <AboutUsLocationSection />
    </div>
  );
};

export default withComponentName(withMetatag(AboutUsComponent, 'about'));
